module.exports = __webpack_public_path__ + "img/money.64e014f9.gif";